import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

export default function CheckoutSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkoutData } = location.state || {};

  useEffect(() => {
    if (!checkoutData) {
      toast.error('Informações de pagamento não encontradas');
      setTimeout(() => navigate('/'), 3000);
    }
  }, [checkoutData, navigate]);

  const handleGoToDashboard = () => {
    navigate('/');
    toast.success('Redirecionando…');
  };

  return (
    <div className="min-h-screen bg-muted/30 flex flex-col">
      <header className="py-4 bg-white border-b border-border">
        <div className="container px-4 mx-auto">
          <div className="flex items-center">
            <img src="/brand/logo-secundario.svg" alt="dgenny" className="h-9" />
          </div>
        </div>
      </header>

      <main className="container px-4 mx-auto py-12 flex-grow flex items-center justify-center">
        <div className="max-w-2xl w-full">
          <Card className="p-10 text-center border-border rounded-3xl">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-brand-rosa/30 rounded-full flex items-center justify-center">
                <CheckCircle size={44} className="text-brand-roxo" />
              </div>
            </div>

            <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-3">
              Pagamento confirmado
            </h1>

            <p className="text-brand-azul/70 mb-8 leading-relaxed">
              Sua assinatura do plano <span className="font-semibold text-brand-azul">{checkoutData?.planName || 'selecionado'}</span> foi ativada.
              Você vai receber um e-mail com os detalhes.
            </p>

            <div className="bg-muted/60 p-5 rounded-2xl mb-8 text-left">
              <h2 className="font-display font-bold text-lg text-brand-azul mb-3">Resumo</h2>

              {checkoutData && (
                <div className="space-y-2 text-sm text-brand-azul/80">
                  <div className="flex justify-between">
                    <span>Plano</span>
                    <span className="font-medium">{checkoutData.planName}</span>
                  </div>

                  <div className="flex justify-between">
                    <span>Contas WhatsApp</span>
                    <span className="font-medium">{checkoutData.whatsappAccounts}</span>
                  </div>

                  {checkoutData.extraNegotiationsPacks > 0 && (
                    <div className="flex justify-between">
                      <span>Pacotes extras</span>
                      <span className="font-medium">{checkoutData.extraNegotiationsPacks}</span>
                    </div>
                  )}

                  <div className="flex justify-between border-t border-border pt-2 mt-2 font-semibold text-brand-azul">
                    <span>Total mensal</span>
                    <span>R$ {checkoutData.totalPrice.toFixed(2)}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="space-y-4">
              <Button
                onClick={handleGoToDashboard}
                className="bg-brand-roxo hover:bg-brand-roxo/90 text-white py-3 px-8 rounded-full font-semibold text-base w-full"
              >
                Ir para a home
              </Button>

              <p className="text-sm text-brand-azul/60">
                Precisa de ajuda? <a href="mailto:compre.ai@dgenny.com.br" className="text-brand-roxo font-semibold hover:underline">Fale com a gente</a>
              </p>
            </div>
          </Card>
        </div>
      </main>

      <footer className="py-6 bg-white border-t border-border">
        <div className="container px-4 mx-auto text-center text-brand-azul/50 text-xs">
          <p>&copy; {new Date().getFullYear()} dgenny. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
